// Supabase returns at most 1,000 rows per request. This reads every page of one query so a business with a long
// history never gets silently cut-short numbers.
//
// buildQuery must return a FRESH query each call, with the table, select and filters already applied
// (for example: () => supabase.from('transactions').select('*').eq('contractor_id', userId)).
// Pages are ordered by a unique column (id by default, then any extra order the caller names) so no row is
// skipped or repeated between pages.
//
// Returns { data, error }. If any page fails, or the safety cap is reached, data is null and error is set:
// partial data is never returned as if it were complete.
const PAGE_SIZE = 1000;
const MAX_PAGES = 100; // 100,000 rows per read; more than this is reported as an error instead of looping forever

async function fetchAllRows(buildQuery, { pageSize = PAGE_SIZE, maxPages = MAX_PAGES, orderBy = [{ column: 'id', ascending: true }] } = {}) {
  const all = [];
  for (let page = 0; page < maxPages; page++) {
    const from = page * pageSize;
    const to = from + pageSize - 1;
    let query = buildQuery();
    for (const o of orderBy) query = query.order(o.column, { ascending: o.ascending !== false });
    let res;
    try {
      res = await query.range(from, to);
    } catch (e) {
      return { data: null, error: e };
    }
    const { data, error } = res || {};
    if (error) return { data: null, error };
    const rows = data || [];
    for (const r of rows) all.push(r);
    if (rows.length < pageSize) return { data: all, error: null };
  }
  return { data: null, error: new Error(`Too many rows to load (more than ${maxPages * pageSize}).`) };
}

export { fetchAllRows, PAGE_SIZE, MAX_PAGES };
